import Api from '../../../../services/api';
import moment from 'moment'
import React, { useEffect, useState } from 'react';
import { message, Form, Spin, Input, Radio, Popconfirm, Tooltip } from 'antd';
import { InputNumber, Button, Select, DatePicker, } from 'antd';
import { useParams, useLocation } from 'react-router-dom';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import './styles.css';
import { idiomas } from '../../../../assets/idiomas';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PermissaoAction from '../../../../redux/actions/permissao';
import MaskedInput from 'react-input-mask'
import MaskedTextInput from 'react-text-mask'
import { validarData } from '../../../../utils/date';
import { ruleDataInvalida } from '../../../../utils/custom-rules-antd';
import { motivoEscolaridadeService } from '../../../../services/Motivo-Escolaridade-Service/motivo-escolaridade-service';
import { dadosCadastraisService } from '../../../../services/Dados-Cadastrais-Service/dados-cadastrais-service';
import { isUndefined } from 'lodash';
import api from '../../../../services/api';
import { maskTelefone, onKeyDownBloquearDigitosPorLength, validarTelefoneCelular } from '../../../../utils/telefone';
import axios from 'axios';
import { CopyOutlined, EditOutlined, InfoCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { copy_to_clipboard } from '../../../../utils/copy-to-clipboard';
import { LocalidadeService } from '../../../../services/Localidade-Service/localidade-service';
import { string } from 'prop-types';


interface props {
    dados: any;
    escolaridades: any;
    numeroDependentes: Number;
    numeroDependentesNoBrasil: Number;
    permissao?: any;
    motivoEscolaridade?: any;
}

const DadosCadastrais: React.FC<props> = (props) => {

    interface Escolaridade {
        escolaridadeID: number;
        descricao: string;
        estudando: boolean;
    }
    const [loading, setLoading] = useState(false);
    const { id } = useParams<Record<string, string | undefined>>();
    const { agendamentoID } = useParams<Record<string, string | undefined>>();
    const [form] = Form.useForm();
    const [escolaridades, setEscolaridades] = useState<Escolaridade[]>([]);
    const [agendamento, setAgendamento] = useState<any>();
    const [show, setShow] = useState(false);
    const [checkedChefe, setCheckedChefe] = useState<boolean>(false);
    const [checkedPossuiDeficiencia, setCheckedPossuiDeficiencia] = useState<boolean>(false);
    const [checkedResideNoBrasil, setCheckedResideNoBrasil] = useState<boolean>(false);
    const [permissaoUserEditar, setPermissaoUserEditar] = useState<boolean>(false);
    const [visibleOutros, setVisibleOutros] = useState<boolean>(false);
    const [obrigatoriedadeDescricao, setObrigatoriedadeDescricao] = useState<boolean>(false);
    const { TextArea } = Input;
    const [popConfirmVisible, setPopConfirmVisible] = useState(false);
    const [jaExisteIdentico, setJaExisteIdentico] = useState(false);
    const [cadastroSemelhanteIdentico, setCadastroSemelhanteIdentico] = useState<any[]>();
    const [paises, setPaises] = useState<any>();
    const [estados, setEstados] = useState<any>();
    const [cidades, setCidades] = useState<any>();
    const [selectedPais, setSelectedPais] = useState<any>();
    const [selectedEstado, setSelectedEstado] = useState<any>();
    const [selectedCidade, setSelectedCidade] = useState<any>();
    const [copied, setCopied] = useState<any>();
    const [loadinCoutry, setLoadinCoutry] = useState(false);


    let location = useLocation();
    var currentLocation = location.pathname

    let paths = currentLocation.split('/');

    useEffect(() => {

        buscaPaises()

        if (agendamentoID != undefined) {
            Api.get(`Agendamento/getbyid?id=${agendamentoID}`).then((res) => {
                form.setFieldsValue({
                    usuarioAtendimentoNome: res.data.usuarioAtendimentoNome,
                    usuarioAtendimentoID: res.data.usuarioAtendimentoID,
                });
            }).finally(() => {
            });
        }
        else {
            form.setFieldsValue({
                usuarioAtendimentoNome: "",
                usuarioAtendimentoID: 0,
            });
        }
        let dataNascimento = new Date(Date.parse(props.dados?.dataNascimento)).toLocaleDateString();
        // let dataMatricula = new Date(Date.parse(props.dados?.dataMatricula)).toLocaleDateString();

        setSelectedPais(props.dados?.pais)
        setSelectedEstado(props.dados?.estadoProvincia)
        setSelectedCidade(props.dados?.municipioNascimento)

        form.setFieldsValue({
            nome: props.dados?.nome,
            pais: props.dados?.pais,
            dataNascimento: props.dados?.dataNascimento ?
                dataNascimento : null,
            nomePai: props.dados?.nomePai,
            nomeMae: props.dados?.nomeMae,
            sexo: props.dados?.sexo,
            estadoCivil: props.dados?.estadoCivil,
            municipioNascimento: props.dados?.municipioNascimento,
            estadoProvincia: props.dados?.estadoProvincia,
            idioma: props.dados?.idioma,
            nomeSocial: props.dados?.nomeSocial,
            estudando: props.dados?.estudando,
            instituicao: props.dados?.instituicao,
            dependentes: props.dados?.dependentes,
            dependentesNoBrasil: props.dados?.dependentesNoBrasil,
            chefeFamilia: props.dados?.chefeFamilia,
            telefone: maskTelefone(props.dados?.telefone == null ? "" : props.dados?.telefone.replace(/\W/g, '')),
            possuiDeficiencia: props.dados?.possuiDeficiencia,
            deficiencia: props.dados?.deficiencia,
            motivoEscolaridadeID: props.dados?.motivoEscolaridadeID == null ? null : props.dados?.motivoEscolaridade?.descricaoOutros == true ? 'outros' : props.dados?.motivoEscolaridadeID,
            descricao: props.dados?.descricaoMotivoEscolaridade || '',
            usuarioPreCadastroNome: props.dados?.usuarioPreCadastroNome,
            usuarioPreCadastroID: props.dados?.usuarioPreCadastroID,
        });
        if (props.dados?.motivoEscolaridade?.descricaoOutros == true) {
            setVisibleOutros(true)
        }

        if (props.dados?.estudando != undefined && props.dados?.estudando == true) {
            form.setFieldsValue({ escolaridadeID: props.dados?.escolaridadeID });
        }
        else {
            form.setFieldsValue({ escolaridadeID2: props.dados?.escolaridadeID });
        }
        if (paths[4] == "agendamento" && props.permissao[0].permissaoAcesso?.editar == false) {
            setPermissaoUserEditar(true);
        } else {
            setPermissaoUserEditar(props.permissao[0].permissaoAcesso?.editar);
        }
        form.setFieldsValue({ dependentes: props.numeroDependentes });
        form.setFieldsValue({ dependentesNoBrasil: props.numeroDependentesNoBrasil });
        setCheckedPossuiDeficiencia(props.dados?.possuiDeficiencia ? true : false);
        setCheckedChefe(props.dados?.chefeFamilia ? props.dados?.chefeFamilia : false)
        setCheckedResideNoBrasil(props.dados?.resideNoBrasil != undefined ? props.dados?.resideNoBrasil : true)
        setEscolaridades(props.escolaridades)
        setShow(props.dados?.estudando ? props.dados?.estudando : false)

        if (props.motivoEscolaridade != undefined) {
            var negadoMatricula = props.motivoEscolaridade?.find((me: any) => me.descricao === 'NEGADO MATRÍCULA');
            setObrigatoriedadeDescricao(negadoMatricula.motivoEscolaridadeID === props.dados?.motivoEscolaridadeID ? true : false)
        }




    }, [props.dados, props.escolaridades, props.numeroDependentes, props.numeroDependentesNoBrasil])

    // useEffect(()=>{
    //     buscaEstados(paises,selectedPais)
    // },[selectedPais])
    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [DD, MM, YYYY] = dateTimeString.split('/');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD}`;
    }

    const validarDataNascimento = (_: any, value: { number: number }) => {
        if (form.getFieldValue("dataNascimento") != undefined) {
            let result, dataNascimento;
            let dataNascimentoFormatada = toISOFormat(form.getFieldValue("dataNascimento"));
            dataNascimento = new Date(dataNascimentoFormatada);
            result = moment(dataNascimento).isValid();
            if (result == false) {
                return Promise.reject(new Error('Data Nascimento inválida!'));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    const onChangeMotivoEscolaridade = (e: any) => {
        var negadoMatricula = props.motivoEscolaridade.find((me: any) => me.descricao == 'NEGADO MATRÍCULA');
        setObrigatoriedadeDescricao(negadoMatricula.motivoEscolaridadeID === e ? true : false)

        if (e === "outros") {
            form.setFieldsValue({ descricao: null })
            setVisibleOutros(true)
        } else {
            setVisibleOutros(false)
        }
    }

    const renderPopConfirmTitleCadastrosSemelhantes = () => (
        <>
            Encontramos um cadastro semelhante na base de dados. <br />
            Cadastro(s) encontrado(s):  <br />
            {cadastroSemelhanteIdentico?.map(c => (
                <> <span>-{c.nome}</span> - {c.pais} - {moment(c.dataNascimento).format("DD/MM/YYYY")}<br /> </>
            )
            )}
            Deseja proceder com a edição dos dados cadastrais?
        </>
    );

    const renderMessageCadastrosIdenticos = (data: any[]) => {
        return (
            <>
                Não é possível realizar a edição dos dados de cadastro pois encontramos um registro idêntico na base de dados. Cadastro(s) encontrado(s):  <br />
                {data?.map(c => (
                    <> <span>-{c.nome}</span> - {c.pais} - {moment(c.dataNascimento).format("DD/MM/YYYY")}<br /> </>
                )
                )}
            </>
        );
    }

    const buscaPaises = async () => {

        let paises = await LocalidadeService.getPaises(setLoadinCoutry);

        setPaises(paises);

        if (!isUndefined(props.dados?.pais)) {
            setSelectedPais(props.dados?.pais)
            buscaEstados(paises, props.dados?.pais)
        }

    }

    const buscaEstados = async (paises: any, paisName: string, novoPais: boolean = false) => {

        setSelectedPais(paisName?.toUpperCase());


        let estadosOrdenados = await LocalidadeService.getEstados(setLoadinCoutry, paisName);

        setEstados(estadosOrdenados);

        if (novoPais) {
            setSelectedEstado(null)
            setSelectedCidade(null)
            setCidades([]);

        } else {
            buscaCidades(selectedEstado);
        }

    }

    const buscaCidades = async (estadoName: string, novoEstado: boolean = false) => {
        setSelectedEstado(estadoName?.toUpperCase())

        if (novoEstado) {
            setSelectedCidade(null);
        }

        let cidades = await LocalidadeService.getCidade(setLoadinCoutry, estadoName);

        setCidades(cidades);


}

const attCidade = (cidadeName: any) => {

    setSelectedCidade(cidadeName?.toUpperCase());

}

const validarSemelhanteIdentico = (teste: any) => {
    form.validateFields().then(() => {
        setPopConfirmVisible(false);
        message.destroy();
        let values = form.getFieldsValue();

        if (!isUndefined(values.nome) && !isUndefined(values.dataNascimento) && !isUndefined(values.pais) && !isUndefined(values.telefone)) {
            setLoading(true);

            api.post("DadosCadastrais/validaridenticosemelhante", {
                DadosCadastraisID: id ? parseInt(id) : 0,
                Nome: values.nome.toUpperCase(),
                DataNascimento: values.dataNascimento ? moment(values.dataNascimento, "DD/MM/YYYY").format("YYYY-MM-DD") : undefined,
                Pais: values.pais,
            })
                .then((response) => {

                    if (response.data.valido) {

                        setPopConfirmVisible(false);
                        setJaExisteIdentico(false);
                        submit();
                    }
                    else {
                        setCadastroSemelhanteIdentico(response.data.cadastro)
                        if (response.data.ehIdentico) {

                            message.error({ content: renderMessageCadastrosIdenticos(response.data.cadastro), duration: 10, key: 1 })
                            setJaExisteIdentico(true);
                        }
                        else {
                            // message.warning({ content: 'Encontramos um cadastro semelhante na base de dados. Cadastro encontrado: ' + response.data.cadastro, duration: 10, key: 1 })
                            setPopConfirmVisible(true);
                            setJaExisteIdentico(false);
                        }
                    }
                })
                .catch((err) => {
                    message.error(err?.response?.data || 'Falha na requisição', 10)
                })
                .finally(() => setLoading(false))
        }
    })
};

const submit = async () => {
    let value = form.getFieldsValue();
    setPopConfirmVisible(false);
    setLoading(true);
    if (value.estudando === true) {
        form.setFieldsValue({ escolaridadeID2: null });
    }

    else {
        form.setFieldsValue({ instituicao: "", escolaridadeID: null, matriculaRealizada: null });
    }

    let dataNascimento;

    if (value.dataNascimento != undefined) {
        let dataFormatada = toISOFormat(value.dataNascimento);
        dataNascimento = new Date(dataFormatada);
    }

    let dadosCadastrais = {
        DadosCadastraisID: id ? parseInt(id) : 0,
        Nome: value.nome,
        DataNascimento: dataNascimento,
        Pais: selectedPais,
        NomePai: value.nomePai,
        NomeMae: value.nomeMae,
        Sexo: value.sexo,
        EstadoCivil: value.estadoCivil,
        MunicipioNascimento: selectedCidade,
        EstadoProvincia: selectedEstado,
        Idioma: value.idioma,
        EscolaridadeID: value.estudando === true ? value.escolaridadeID : value.escolaridadeID2,
        NomeSocial: value.nomeSocial,
        Estudando: value.estudando,
        Instituicao: value.instituicao,
        AgendamentoID: agendamentoID ? parseInt(agendamentoID) : 0,
        ChefeFamilia: checkedChefe,
        Telefone: value.telefone,
        PossuiDeficiencia: value.possuiDeficiencia,
        Deficiencia: value.deficiencia,
        UsuarioPreCadastroNome: value.usuarioPreCadastroNome,
        UsuarioPreCadastroID: value.usuarioPreCadastroID,
        DescricaoMotivoEscolaridade: value.descricao,
        Ativo: props.dados?.ativo,
    }


    await Api.put("DadosCadastrais", {
        ...dadosCadastrais,
        motivoEscolaridadeID: value.motivoEscolaridadeID,
    })
        .then((response) => {
            message.success('Salvo com sucesso')
            setLoading(false);
        })
        .catch((err) => {
            message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição', 10)
            setLoading(false);
        });
    // }


}

const definirChefeFamilia = (value: any) => {
    setCheckedChefe(value)
    setCheckedResideNoBrasil(value)
}

const campoLimpo = async (tipo: any) => {
    if (tipo == "campoPais") {
        await buscaPaises();
    } else if (tipo == "campoEstado") {
        await buscaEstados(paises, selectedPais);
    } else if (tipo == "campoCidade") {
        await buscaCidades(selectedEstado);
    }

}

const copiarText = async (text: string) => {

    copy_to_clipboard(text)
    setCopied(true);
    setTimeout(() => {
        setCopied(false)
    }, 5000);
}

function validarValor(value: any) {
    if (!!value) {
        return Promise.resolve();
    } else {
        return Promise.reject("Campo Obrigatório");
    }
}

function limparLoc(value: 'pais' | 'estado' | 'cidade') {
    switch (value) {
        case 'pais':
            setPaises([]);
            setSelectedPais(null);
            setEstados([]);
            setSelectedEstado(null);
            setCidades([]);
            setSelectedCidade(null);
            break;

        case 'estado':
            setEstados([]);
            setSelectedEstado(null);
            setCidades([]);
            setSelectedCidade(null);
            break;

        case 'cidade':
            setCidades([]);
            setSelectedCidade(null);
            break;
    }
}



return (
    <div className="container">
        <div className="form-pesquisa">
            <Form onFinish={submit}
                form={form}
                labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                layout="horizontal"
                onChange={() => setPopConfirmVisible(false)}
                size="middle"
            >
                <div className="row">
                    <div className="col-md-4">
                        <Form.Item name="nome" label="Nome"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira um nome!',
                                }
                            ]}>

                            <Input placeholder="Informe o nome"
                                disabled={permissaoUserEditar === false}
                            />
                        </Form.Item>
                    </div>
                    <div className="col-md-2">
                        <Form.Item name="sexo" label="Sexo"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor informe o sexo!'
                                }
                            ]}>

                            <Select
                                placeholder="selecione"
                                disabled={permissaoUserEditar === false}
                            >
                                <Select.Option value="MASCULINO">Masculino</Select.Option>
                                <Select.Option value="FEMININO">Feminino</Select.Option>
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-md-3">
                        <Form.Item name="estadoCivil" label="Estado Civil"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira um estado civil!',
                                }
                            ]}>

                            <Select
                                placeholder="selecione um estado civil"
                                disabled={permissaoUserEditar === false}
                            >
                                <Select.Option value="SOLTEIRO">Solteiro(a)</Select.Option>
                                <Select.Option value="CASADO">Casado(a)</Select.Option>
                                <Select.Option value="DIVORCIADO">Divorciado(a)</Select.Option>
                                <Select.Option value="SEPARADO">Separado(a)</Select.Option>
                                <Select.Option value="VIUVO">Viúvo(a)</Select.Option>
                                <Select.Option value="UNIAOESTAVEL">União Estável</Select.Option>
                                <Select.Option value="OUTROS">Outros</Select.Option>
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-md-3">
                        <Form.Item name="idioma" label="Idioma"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira um idioma!',
                                }
                            ]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                placeholder="selecione idiomas"
                                disabled={permissaoUserEditar === false}
                            >
                                {idiomas.map((i, index) => <Select.Option key={index} value={i}>{i}</Select.Option>)}
                            </Select>

                        </Form.Item>
                    </div>
                </div >
                <div className="row">
                    <div className="col-md-4">
                        <Form.Item name="nomeSocial" label="Nome Social" >
                            <Input placeholder="Informe o nome social"
                                disabled={permissaoUserEditar === false}
                            />
                        </Form.Item>
                    </div>
                    <div className="col-md-4">
                        <Form.Item name="nomeMae" label="Nome da Mãe" >
                            <Input placeholder="Informe o nome da mãe"
                                disabled={permissaoUserEditar === false}
                            />
                        </Form.Item>
                    </div>
                    <div className="col-md-4">
                        <Form.Item name="nomePai" label="Nome do Pai" >
                            <Input placeholder="Informe o nome do pai"
                                disabled={permissaoUserEditar === false}
                            />
                        </Form.Item>
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-3">

                        <Form.Item name="pais" label={(<>
                            <span style={{ 'marginRight': '5px' }}>País</span>
                            <Tooltip title=" 1- Caso necessite visualizar o nome dos países em portugês, traduza a página com o tradutor padrão do navegador e clique no campo novamente.">
                                <InfoCircleOutlined style={{ 'color': 'blue' }} />
                            </Tooltip>
                            <Tooltip title={copied ? "Copiado" : "Copiar"}>
                                <Button style={{ 'border': 'none' }} onClick={() => copiarText(selectedPais)}><CopyOutlined /></Button>
                            </Tooltip>

                        </>)}
                            rules={[
                                { validator: (_, value) => { return validarValor(selectedPais) } }
                            ]}
                        >
                            {paises?.length > 0 ?
                                <Spin spinning={loadinCoutry}>
                                    <div className="selectStyle">

                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            placeholder="selecione um país"
                                            disabled={permissaoUserEditar === false}
                                            onChange={(e) => buscaEstados(paises, e, true)}
                                            value={selectedPais}

                                        >
                                            {paises?.map((p: any, index: any) => <Select.Option key={index} value={p.name}>{p.name.toUpperCase()}</Select.Option>)}
                                        </Select>
                                        <Tooltip title="Editar">
                                            <Button onClick={() => limparLoc('pais')}><EditOutlined /></Button>
                                        </Tooltip>
                                    </div>
                                </Spin> :
                                <div>
                                    <Input
                                        onBlur={(e) => setSelectedPais(e.target?.value)}
                                        style={{ 'maxWidth': '200px' }}>
                                    </Input>
                                    <Tooltip title="Recarregar">
                                        <Button onClick={() => campoLimpo("campoPais")}>< SyncOutlined /></Button>
                                    </Tooltip>
                                </div>
                            }

                        </Form.Item>


                    </div>
                    <div className="col-md-3">

                        <Form.Item name="estadoProvincia" label={(<>
                            <span style={{ 'marginRight': '5px' }}>Estado/Província</span>

                            <Tooltip title={copied ? "Copiado" : "Copiar"}>
                                <Button style={{ 'border': 'none' }} onClick={() => copiarText(selectedEstado)}><CopyOutlined /></Button>
                            </Tooltip>

                        </>)}
                            rules={[

                                { validator: (_, value) => { return validarValor(selectedEstado) } }

                            ]}>

                            {estados?.length > 0 ?
                                <Spin spinning={loadinCoutry}>
                                    <div className="selectStyle">

                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            placeholder="selecione um Estado"
                                            disabled={permissaoUserEditar === false}
                                            onChange={(e) => buscaCidades(e, true)}
                                            value={selectedEstado}

                                        >
                                            {estados?.map((p: any, index: any) => <Select.Option key={index} value={p.name}>{p.name.toUpperCase()}</Select.Option>)}
                                        </Select>
                                        <Tooltip title="Editar">
                                            <Button onClick={() => limparLoc('estado')}><EditOutlined /></Button>
                                        </Tooltip>

                                    </div>

                                </Spin>
                                :
                                <>
                                    <Input
                                        onChange={(e) => setSelectedEstado(e.target?.value)}

                                        value={selectedEstado}
                                        style={{ 'maxWidth': '200px' }}

                                    >
                                    </Input>
                                    <Tooltip title="Recarregar">
                                        <Button onClick={() => campoLimpo("campoEstado")}>< SyncOutlined /></Button>
                                    </Tooltip>
                                </>
                            }
                        </Form.Item>
                    </div>
                    <div className="col-md-3">
                        <Form.Item name="municipioNascimento" label={(<>
                            <span style={{ 'marginRight': '5px' }}>Cidade Natal</span>

                            <Tooltip title={copied ? "Copiado" : "Copiar"}>
                                <Button style={{ 'border': 'none' }} onClick={() => copiarText(selectedCidade)}><CopyOutlined /></Button>
                            </Tooltip>
                        </>)}
                            rules={[
                                { validator: (_, value) => { return validarValor(selectedCidade) } }

                            ]}

                        >

                            {cidades?.length > 0 ?
                                <Spin spinning={loadinCoutry}>
                                    <div className="selectStyle">
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            placeholder="Selecione uma cidade"
                                            disabled={permissaoUserEditar === false}
                                            onChange={(e) => { attCidade(e) }}
                                            value={selectedCidade}
                                        >
                                            {cidades?.sort().map((p: any, index: any) => <Select.Option key={index} value={p.name}>{p.name.toUpperCase()}</Select.Option>)}
                                        </Select>
                                        <Tooltip title="Editar">
                                            <Button onClick={() => limparLoc('cidade')}><EditOutlined /></Button>
                                        </Tooltip>

                                    </div>
                                </Spin>
                                :
                                <div>
                                    <Input
                                        onChange={(e) => setSelectedCidade(e.target.value)}
                                        value={selectedCidade}
                                        style={{ 'maxWidth': '200px' }}
                                    // onChange={(e) => campoLimpo(e, "campoCidade")}
                                    >
                                    </Input>
                                    <Tooltip title="Recarregar">
                                        <Button onClick={() => campoLimpo("campoCidade")}>< SyncOutlined /></Button>
                                    </Tooltip>
                                </div>

                            }
                        </Form.Item>

                    </div>
                    <div className="col-md-3">
                        <Form.Item name="dataNascimento" label="Data de Nascimento" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira uma data!',
                                    validator: validarDataNascimento
                                }
                            ]}>
                            <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />

                            {/* <DatePicker
                                    style={{ width: '100%' }}
                                    format="DD/MM/YYYY"
                                    placeholder="01/01/1111"
                                    disabled={permissaoUserEditar === false}
                                /> */}
                        </Form.Item>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <Form.Item name="telefone" label="Telefone" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor, insira um telefone!',
                                },
                                {
                                    validator: (_, value) => validarTelefoneCelular(value), validateTrigger: "onSubmit"
                                }
                            ]}>
                            <MaskedTextInput className="ant-input" placeholder="informe um telefone"
                                onKeyDown={(e: any) => { onKeyDownBloquearDigitosPorLength(e, 11) }}
                                mask={(value: any) => {
                                    if (value && value.replace(/\D/g, '').length >= 11) {
                                        return [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                                    } else {
                                        return [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                                    }
                                }}
                                disabled={permissaoUserEditar === false}
                            />
                        </Form.Item>
                    </div>
                    <div className="col-md-4">
                        <Form.Item name="possuiDeficiencia" label="Possui Deficiência?" rules={[
                            {
                                required: true,
                                message: 'Por favor informe este campo!'
                            }
                        ]}>
                            <Radio.Group defaultValue={false} onChange={(e: any) => {
                                setCheckedPossuiDeficiencia(e.target.value);

                            }}
                                disabled={permissaoUserEditar === false}
                            >
                                <Radio.Button key="true" value={true}>

                                    Sim
                                </Radio.Button>
                                <Radio.Button key="false" value={false}>
                                    Não
                                </Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </div>
                    {checkedPossuiDeficiencia ?
                        <div className="col-md-4">
                            <Form.Item name="deficiencia" label="Deficiência"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor insira a descrição!',
                                    }
                                ]}>

                                <Input placeholder="Informe qual a deficiência"
                                    disabled={permissaoUserEditar === false}
                                />
                            </Form.Item>
                        </div>
                        : null
                    }
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <Form.Item name="estudando" label="Está estudando?" rules={[
                            {
                                required: true,
                                message: 'Por favor informe este campo!',
                            }
                        ]}>
                            <Radio.Group defaultValue={false} onChange={(e: any) => {
                                setShow(e.target.value);
                                if (e.target.value.true) {
                                    form.setFieldsValue({ motivoEscolaridadeID: null, escolaridadeID2: null })
                                } else
                                    form.setFieldsValue({ instituicao: null, escolaridadeID: null })
                            }}
                                disabled={permissaoUserEditar === false}
                            >
                                <Radio.Button key="true" value={true}>
                                    Sim
                                </Radio.Button>
                                <Radio.Button key="false" value={false}>
                                    Não
                                </Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </div>
                    {show ? <>
                        <div className="col-md-4">
                            <Form.Item name="instituicao" label="Nome da Instituição">
                                <Input
                                    disabled={permissaoUserEditar === false}
                                ></Input>
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item name="escolaridadeID" label="Formação escolar:">
                                <Select
                                    placeholder="selecione a escolaridade"
                                    disabled={permissaoUserEditar === false}
                                >
                                    {escolaridades != undefined ? escolaridades.map((option, index) => {
                                        if (option.estudando) {
                                            return <Select.Option key={index} value={option.escolaridadeID}>
                                                {option.descricao}
                                            </Select.Option>;
                                        }
                                    }
                                    ) : null}
                                </Select>
                            </Form.Item>
                        </div>

                    </> :
                        <>
                            <div className="col-md-4">
                                <Form.Item
                                    name="motivoEscolaridadeID"
                                    label="Motivo"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor selecione este campo!',
                                        }
                                    ]}

                                >
                                    <Select
                                        onChange={(e) => onChangeMotivoEscolaridade(e)}
                                        showSearch
                                        placeholder="Selecione um motivo"
                                        // label="tex"
                                        disabled={permissaoUserEditar === false}
                                    >
                                        <Select.Option value="selecione" disabled>Selecione</Select.Option>
                                        {props.motivoEscolaridade != undefined ? props.motivoEscolaridade
                                            .sort((a: any, b: any) => a.descricao.localeCompare(b.descricao))
                                            .map((option: any, index: any) => {
                                                return option.descricaoOutros ? null :
                                                    <Select.Option key={index} value={option.motivoEscolaridadeID}>
                                                        {option.descricao}
                                                    </Select.Option>;
                                            }
                                            ) : null}
                                        {/* <Select.Option value="outros">Outros</Select.Option> */}
                                    </Select>
                                </Form.Item>
                                {/* {visibleOutros ? */}
                                <Form.Item
                                    name="descricao"
                                    label="Digite a descrição do motivo"
                                    rules={[
                                        {
                                            required: obrigatoriedadeDescricao,
                                            message: 'Por favor informe este campo!',
                                        }
                                    ]}
                                >
                                    <TextArea maxLength={250} rows={3} placeholder='Digite o motivo' />
                                </Form.Item>
                                {/* : null} */}
                            </div>
                            <div className="col-md-4">
                                <Form.Item name="escolaridadeID2" label="Última formação escolar:">
                                    <Select
                                        placeholder="selecione sua escolaridade"
                                        disabled={permissaoUserEditar === false}
                                    >
                                        {escolaridades != undefined ? escolaridades.map((option, index) => {
                                            if (!option.estudando) {
                                                return <Select.Option key={index} value={option.escolaridadeID}>
                                                    {option.descricao}
                                                </Select.Option>;
                                            }
                                        }
                                        ) : null}
                                    </Select>
                                </Form.Item>

                            </div> </>}
                </div>
                <br />
                <div className="row">
                    <div className="col-md-2">
                        <Form.Item name="chefeFamilia" >
                            <Checkbox checked={checkedChefe}
                                disabled={permissaoUserEditar === false}
                                onChange={(e: any) => { definirChefeFamilia(e.target.checked) }}>Chefe da família</Checkbox>
                        </Form.Item>
                    </div>
                    {checkedChefe ?
                        <>
                            <div className="col-sm-3">
                                <Form.Item name="dependentes" label="Dependentes" labelCol={{ span: 11 }} wrapperCol={{ span: 16 }} extra="Total de dependentes cadastrados">
                                    <InputNumber readOnly min={0}
                                        disabled={true}
                                    ></InputNumber>
                                </Form.Item>
                            </div>
                            <div className="col-md-4">
                                <Form.Item name="dependentesNoBrasil" label="Dependentes no Brasil" labelCol={{ span: 14 }} wrapperCol={{ span: 16 }}>
                                    <InputNumber readOnly min={0}
                                        disabled={true}
                                    ></InputNumber>
                                </Form.Item>
                            </div>

                        </> : null}
                    {/* <div className="col-md-3">
                            <Form.Item name="resideNoBrasil" >
                                <Checkbox checked={checkedResideNoBrasil}
                                    disabled={permissaoUserEditar === false || checkedChefe}
                                    onChange={(e: any) => { setCheckedResideNoBrasil(e.target.checked) }}>Reside no Brasil</Checkbox>
                            </Form.Item>
                        </div> */}
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Form.Item name="usuarioPreCadastroNome" label="Pré-Cadastro realizado por" >
                            <Input disabled></Input>
                        </Form.Item>
                        <Form.Item hidden name="usuarioPreCadastroID">
                            <Input disabled></Input>
                        </Form.Item>
                    </div>
                    {form.getFieldValue('usuarioAtendimentoID') != 0 ?
                        <div className="col-md-6">
                            <Form.Item name="usuarioAtendimentoNome" label="Atendido por" >
                                <Input disabled></Input>
                            </Form.Item>
                            <Form.Item hidden name="usuarioAtendimentoID" label="Usuário Atendimento">
                                <Input disabled></Input>
                            </Form.Item>
                        </div>
                        :
                        null
                    }
                </div>


                <br />
                <div className="row">
                    <div className="col-md-3">
                        <Form.Item >

                            {permissaoUserEditar === true ?
                                <>
                                    <Popconfirm
                                        title={renderPopConfirmTitleCadastrosSemelhantes}
                                        onConfirm={submit}
                                        onCancel={() => { setPopConfirmVisible(false) }}
                                        okText="Sim"
                                        cancelText="Não"
                                        visible={popConfirmVisible}
                                    >
                                        <Button type="primary" htmlType="button" onClick={validarSemelhanteIdentico} >
                                            Salvar
                                        </Button>
                                    </Popconfirm>
                                </>
                                : null
                            }
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </div>
    </div>
);
}
const mapStateToProps = (state: any) => ({
    permissao: state.permissao,
})


const mapDispatcToProps = (dispatch: any) => bindActionCreators(PermissaoAction, dispatch)


export default connect(mapStateToProps, mapDispatcToProps)(DadosCadastrais);

